
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { branchmaster, logindata } from "../../services/login";

const Login = () => {
  const navigate = useNavigate();
  const [uname, setUname] = useState("superadmin@amytechnologies.com");
  const [pass, setPass] = useState("Amy2024");
  const [branch, setBranch] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [blist, setBlist] = useState([]);
  useEffect(() => {
    branchmaster().then((res) => {
      if (res.status === true) {
        setBlist(res.data);
      }
    })
  }, [])
  const [errmsg, setErrmsg] = useState("");
  function submitlogin(e) {
    e.preventDefault();
    setErrmsg("");
    setSubmitted(true);
    localStorage.clear();

    if (uname !== "" && pass !== "" && branch !== "") {
      const temp = new FormData();
      temp.append("username", uname);
      temp.append("password", pass);
      temp.append("branch_id", branch);

      logindata(temp).then((response) => {
        if (response.status === true) {
          localStorage.setItem("UID", response.data.user_details.id);
          localStorage.setItem("User", response.data.user_details.name);
          localStorage.setItem("Role", response.data.user_details.role);
          localStorage.setItem("password", pass);
          localStorage.setItem("branch", branch);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("branches", response.data.user_details.branch);

          if (response.data.user_details.role == 1) {
            navigate("/superadmin/dashboard");
          } else if (response.data.user_details.role == 3) {
            navigate("/employee/dashboard");
          } else if (response.data.user_details.role == 2) {
            navigate("/superadmin/dashboard");
          }
        } else {
          setErrmsg(response.message);
        }
      })
    }
  }

  return (
    <div className="full-page-container">

      <Container fluid className="login-container d-flex align-items-center justify-content-center">
        <Row className="login-box shadow">
          <Col md={6} className="form-section p-4">
            <img className="logo-img mb-2" src={require("../../assets/images/logo/service_logo.png")} />
            <p className="text-center text-muted">Sign in to Golden Global Credit Private Limited.</p>
            {/* <p className="text-center text-muted">Sign in to AMY Microfinance Software.</p> */}

            <Form>
              <Form.Group className="mb-3" controlId="formUsername">
                <Form.Label className="inputtitle">Username</Form.Label>
                <Form.Control className="text-mutedd" type="text" placeholder="Enter Username" value={uname} onChange={(e) => setUname(e.target.value)} />
                {submitted && !uname && (
                  <span className="text-danger">Username is required</span>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label className="inputtitle">Password</Form.Label>
                <Form.Control className="text-mutedd" type="password" placeholder="Enter Password" value={pass} onChange={(e) => setPass(e.target.value)} />
                {submitted && !pass && (
                  <span className="text-danger">Password is required</span>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label className="inputtitle">Branch</Form.Label>
                <Form.Control
                  as="select"
                  value={branch}
                  onChange={(e) => setBranch(e.target.value)}
                >
                  <option value="">Select Branch</option>
                  {blist.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.branch_name}
                    </option>
                  ))}
                </Form.Control>
                {submitted && !branch && (
                  <span className="text-danger">Branch is required</span>
                )}
              </Form.Group>
              {errmsg && <span className="text-danger">{errmsg}</span>}
              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* <a className="text-muted small">Forgot your password?</a> */}
              </div>

              <Button variant="success" type="submit" className="w-100 mb-4" onClick={submitlogin}>Log In</Button>
            </Form>

          </Col>

          <Col md={6} className="info-section d-none d-md-flex align-items-center justify-content-center">
            <div className="text-center">
              <div className="text-center mb-4">
                <img className="logo-imgg mb-2" src={require("../../assets/images/logo/logo.png")} />


              </div>
              <h3>"Empowering your financial future"</h3>
              {/* <p className="text-white">Sign in to continue to AMY Microfinance Software and manage your financial journey with ease.</p> */}

              <p className="text-muted">Sign in to continue to Golden Global Credit Private Limited and manage your financial journey with ease.</p>
            </div>
          </Col>

        </Row>

      </Container>
      <div className="footer">
        <div className="row">
          <div className="col-md-6 text-left">
            {/* <span>Copyrights © 2025 <a className='text-danger' >AMY Microfinance Software</a>. All Rights Reserved</span> */}
            <span>Copyrights © 2025 <a className='text-danger' href="https://goldenglobal.in" target='_blank'>Golden Global Credit Private Limited</a>. All Rights Reserved</span>
          </div>
          {/*  */}
          <div className="col-md-6 text-end">
            <span>Powered by <a href="https://amytechnologies.in/" target="_blank" className="dark-primary font-weight-bold">AMY Technologies</a></span>
          </div>
        </div>
      </div>
    </div>

  );
};


export default Login;
